<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <span>Public Files</span>
            <button class="pull-right btn btn-sm btn-primary" @click="uploadNewFile">
              Upload file
            </button>
            <button class="pull-right btn btn-sm btn-primary" @click="updateFileStructure">
              Update list
            </button>
          </div>

          <div class="card-block spinner-parent">
            <spinner
              ref="spinner"
              size="md"
              text="Loading ..."
            />

            <div v-if="rootTree" class="file-manager">
              <SelectelFolder
                v-for="(content, name) in rootTree.folders"
                :key="name"
                :name="name"
                :path="name"
                :content="content"
                @folderDeleted="onFolderDeleted"
                @fileDeleted="onFileDeleted"
              />
              <File
                v-for="file in rootTree.files"
                :key="file.basename"
                :file="file"
                @fileDeleted="onFileDeleted"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import File from './File';
import { uploadStatus } from '@/helpers/constants';

const { SUCCESS } = uploadStatus;

export default {
  components: {
    File,
  },

  data: () => ({
    rootFolders: [],
    rootFiles: [],
    rootTree: null,
    succeedUploads: [],
  }),

  computed: {
    ...mapGetters('uploadManager', [
      'publicFilesUploads',
    ]),
  },

  watch: {
    publicFilesUploads: {
      handler(val) {
        const finishedUploads = val.filter(item => item.status === SUCCESS);
        if (!finishedUploads.length) return;
        const newSucceedUploads = _.xorBy(finishedUploads, this.succeedUploads, item => item.id);
        newSucceedUploads.forEach((uploadedItem) => {
          this.addUploadedFile(uploadedItem);
          this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
        });
        this.succeedUploads = [
          ...this.succeedUploads,
          ...newSucceedUploads,
        ];
      },
    },
  },

  mounted() {
    this.getFiles();

    this.$root.$on('fileUploaded', () => {
      this.silentGetFiles();
    });
  },

  methods: {
    getFiles() {
      if (this.$refs.spinner) { this.$refs.spinner.show(); }
      this.$apiHttp.get(`${this.$config.app_api.prefix}selectel`)
        .then((response) => {
          this.rootTree = response.data;
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
        })
        .catch((error) => {
          if (this.$refs.spinner) { this.$refs.spinner.hide(); }
          this.$store.dispatch('notifications/setHttpError', { error, text: 'Error in getting files list request' });
          console.error(error);
        });
    },
    silentGetFiles() {
      this.$apiHttp.get(`${this.$config.app_api.prefix}selectel`)
        .then((response) => {
          this.rootTree = response.data;
          this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
        })
        .catch((error) => {
          console.error(error);
        });
    },
    uploadNewFile() {
      $('#selectelUploadModal').modal('show');
    },
    updateFileStructure() {
      this.getFiles();
    },
    addUploadedFile(uploadedItem) {
      const { dir } = uploadedItem;
      let folders = [];
      if (dir !== '/') {
        folders = dir.split('/');
      }
      let selectedFolder = this.rootTree;
      for (let i = 0; i < folders.length; i++) {
        const currFolderName = folders[i];
        if (!currFolderName)  {
          continue;
        }
        const currFolder = selectedFolder.folders[currFolderName];
        if (!currFolder) {
          selectedFolder.folders[currFolderName] = {
            files: [],
            folders: {},
          };
        }
        selectedFolder = selectedFolder.folders[currFolderName];
      }
      selectedFolder.files = [
        ...selectedFolder.files,
        {
          basename: uploadedItem.file.name,
          size: uploadedItem.file.size,
          url: uploadedItem.urls[0],
        },
      ];
      this.rootTree = {
        ...this.rootTree,
      };
    },
    onFileDeleted(deletedFile) {
      if (!this.deleteFileByPathRecursive(deletedFile, this.rootTree)) {
        const dir = deletedFile.dirname;
        this.deleteFileByDirRecursive(dir, this.rootTree);
        this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
      }
    },
    onFolderDeleted(folderName) {
      const newTree = _.cloneDeep(this.rootTree);
      this.deleteFolderByName(folderName, newTree);
      this.$set(this.rootTree, 'folders', newTree.folders);
      this.$root.$emit('updateSelectelFolders', this.extractTreeFolderKeys(this.rootTree, ''));
    },
    deleteFileByPathRecursive(deletedFile, nextFolder) {
      const rootFileIndex = _.findIndex(nextFolder.files, file => file.path === deletedFile.path);
      if (rootFileIndex !== -1) {
        nextFolder.files.splice(rootFileIndex, 1);
        return true;
      }
      let result = false;
      Object.keys(nextFolder.folders).forEach((key) => {
        result = result || this.deleteFileByPathRecursive(deletedFile, nextFolder.folders[key]);
        if (result) {
          return false;
        }
        return true;
      });
      return result;
    },
    deleteFileByDirRecursive(dir, nextFolder) {
      const folders = dir.split('/');
      if (folders.length > 1) {
        const relativePath = folders.slice(0, 1).join('/');
        this.deleteFileByDirRecursive(relativePath, nextFolder.folders[folders[0]]);
      } else {
        const fileIndex = _.findIndex(
          nextFolder.folders[dir].files,
          file => file.path === dir,
        );
        if (fileIndex !== -1) {
          nextFolder.folders[dir].files.splice(fileIndex, 1);
        }
      }
    },
    deleteFolderByName(folderName, folderTree) {
      const folders = folderName.split('/');
      let foldersObject = folderTree.folders;
      if (folders.length > 1) {
        let nextFolder;
        for (let i = 0; i < folders.length - 1; i += 1) {
          nextFolder = foldersObject[folders[i]];
          foldersObject = nextFolder.folders;
        }
        delete foldersObject[folders[folders.length - 1]];
      } else if (folders.length === 1) {
        delete foldersObject[folderName];
      }
    },
    extractTreeFolderKeys(folder, initialName) {
      const dirs = [];
      if (!folder.folders) {
        return [];
      }
      const folderKeys = Object.keys(folder.folders);
      let currentDirectory = '';
      if (initialName !== '') {
        currentDirectory = `${initialName}/`;
      }
      if (folderKeys.length > 0) {
        folderKeys.forEach((key) => {
          const nextDir = `${currentDirectory}${key}`;
          dirs.push(nextDir);
          dirs.splice(0, 0, ...this.extractTreeFolderKeys(folder.folders[key], nextDir));
        });
      }
      return dirs;
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?243c673d